import React from 'react'
import { ArrowDownward } from '@material-ui/icons'
import {
  BlockIcon,
  BuddyIcon,
  ClockIcon,
  CoinStack,
  FinishFlagICon,
  PencilIcon,
  PersonalFinanceBuyoutFeature,
  PersonalFinanceRebus,
  ShieldIcon,
  TakhayerFeature,
  TakhayerFeature1,
  TasksIcon,
  TickIcon,
} from '../../components/SVGIcons'

const flexibleIconList = [
  {
    icon: <TickIcon />,
    description: 'flexible-icon-list tick',
  },
  {
    icon: <TasksIcon />,
    description: 'cars-who-can',
  },
  {
    icon: <BuddyIcon />,
    description: 'flexible-icon-list buddy',
  },
  {
    icon: <BlockIcon />,
    description: 'flexible-icon-list block 1',
  },
  {
    icon: <BlockIcon />,
    description: 'flexible-icon-list block 2',
  },
]
const personalFinanceIconList = [
  {
    icon: <TasksIcon />,
    description: 'flexible-icon-list task',
  },
  {
    icon: <BuddyIcon />,
    description: 'flexible-icon-list buddy',
  },
  {
    icon: <BlockIcon />,
    description: 'flexible-icon-list block 1',
  },
  {
    icon: <BlockIcon />,
    description: 'flexible-icon-list block 2',
  },
]

const selfEmployedIconList = [
  {
    icon: <BlockIcon />,
    description: 'self-employed-icon-list block 1',
  },
  {
    icon: <TasksIcon />,
    description: 'self-employed-icon-list block 2',
  },
  {
    icon: <TickIcon />,
    description: 'self-employed-icon-list block 3',
  },
  {
    icon: <PencilIcon />,
    description: 'self-employed-icon-list block 4',
  },
]
export const productFeaturesData = {
  '50-50': [
    // {
    //   type: 'SIXTY',
    //   subType: 'svg',
    //   title: '50-50-SIXTY-1-title',
    //   subtitle: null,
    //   adjustIconTop: 50,
    //   imageShouldSwitchLocale: true,
    //   imageUrl: '/assets/SVG Assets/SVG - Plain/02-01 Two-Payments Feature.svg',
    //   fancyTitle: null,
    //   ctaTitle: null,
    //   ctaHref: null,
    //   richText: null,
    // },
    {
      type: 'FORTY',
      subType: 'icon',
      title: '50-50-FORTY-1-title',
      subtitle: '50-50-FORTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <CoinStack />,
      richText: null,
    },
    {
      type: 'FORTY',
      subType: 'icon',
      title: '50-50-FORTY-2-title',
      subtitle: null,
      imageUrl:
        '/assets/desktop/Leasing/03-1%20Leasing%20Feature%20Used%20New.jpg',
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      richText: null,
    },
    {
      type: 'HUNDRED',
      subType: 'icon',
      title: 'takhayer-HUNDRED-1-title',
      subtitle: 'takhayer-HUNDRED-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <TakhayerFeature />,
      backgroundColor: 'normal',
      richText: null,
    },
    {
      type: 'SIXTY-FULL',
      subType: 'cta',
      title: 'after-sales-banner-full-main-text',
      titleSuffix: 'after-sales-banner-full-main-text-sffix',
      subtitle: 'after-sales-banner-full-sub-text',
      imageShouldSwitchLocale: false,
      imageUrl: {
        desktop: '/after-sales-banner.png',
        mobile: '/after-sales-banner.png',
      },
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: '/auto-leasing/after-sales-services',
      icon: null,
      richText: null,
    },
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: '50-50-SEVENTY-1-title',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: flexibleIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'auto-leasing-THIRTY-1-title',
      subtitle: 'default-auto-leasing-30-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ShieldIcon />,
      richText: null,
    },
  ],
  monthly: [
    // {
    //   type: 'SIXTY',
    //   subType: 'svg',
    //   title: 'monthly-SIXTY-1-title',
    //   subtitle: null,
    //   imageShouldSwitchLocale: true,
    //   imageUrl: '/assets/SVG Assets/SVG - Plain/02-01 Monthly Feature.svg',
    //   fancyTitle: null,
    //   ctaTitle: null,
    //   ctaHref: null,
    //   richText: null,
    // },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'monthly-FORTY-1-title',
      subtitle: 'monthly-FORTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <CoinStack />,
      richText: null,
    },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'monthly-FORTY-2-title',
      subtitle: null,
      imageUrl:
        '/assets/desktop/Leasing/03-1%20Leasing%20Feature%20Used%20New.jpg',
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      richText: null,
    },
    {
      type: 'HUNDRED',
      subType: 'icon',
      title: 'takhayer-HUNDRED-1-title',
      subtitle: 'takhayer-HUNDRED-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <TakhayerFeature />,
      backgroundColor: 'normal',
      richText: null,
    },
    {
      type: 'SIXTY-FULL',
      subType: 'cta',
      title: 'after-sales-banner-full-main-text',
      titleSuffix: 'after-sales-banner-full-main-text-sffix',
      subtitle: 'after-sales-banner-full-sub-text',
      imageShouldSwitchLocale: false,
      imageUrl: {
        desktop: '/after-sales-banner.png',
        mobile: '/after-sales-banner.png',
      },
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: '/auto-leasing/after-sales-services',
      icon: null,
      richText: null,
    },
    // {
    //   type: 'SIXTY',
    //   subType: 'cta',
    //   title: 'monthly-SIXTY-2-title',
    //   subtitle: null,
    //   imageShouldSwitchLocale: true,
    //   imageUrl: {
    //     desktop:
    //       '/assets/SVG Assets/SVG - Plain/02-06 After Sales Feature Mobile.svg',
    //     mobile:
    //       '/assets/SVG Assets/SVG - With Image/03-02 After Sales Feature Mobile.svg',
    //   },
    //   fancyTitle: null,
    //   ctaTitle: null,
    //   ctaHref: '/auto-leasing/after-sales-services',
    //   icon: null,
    //   richText: null,
    // },
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: 'monthly-SEVENTY-1-title',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: flexibleIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'auto-leasing-THIRTY-1-title',
      subtitle: 'default-auto-leasing-30-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ShieldIcon />,
      richText: null,
    },
  ],
  flexi: [
    // {
    //   type: 'SIXTY',
    //   subType: 'svg',
    //   title: 'flexi-SIXTY-1-title',
    //   subtitle: null,
    //   adjustIconTop: 50,
    //   imageShouldSwitchLocale: true,
    //   imageUrl: {
    //     desktop: '/assets/SVG Assets/SVG - Plain/02-01 Yearly Feature.svg',
    //     mobile:
    //       '/assets/SVG Assets/SVG - Plain/02-01 Yearly Feature Mobile.svg',
    //   },
    //   fancyTitle: null,
    //   ctaTitle: null,
    //   ctaHref: null,
    //   icon: null,
    //   richText: null,
    // },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'flexi-FORTY-1-title',
      subtitle: 'flexi-FORTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: '/auto-leasing/after-sales-services',
      icon: <CoinStack />,
      richText: null,
    },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'flexi-FORTY-2-title',
      subtitle: null,
      imageUrl:
        '/assets/desktop/Leasing/03-1%20Leasing%20Feature%20Used%20New.jpg',
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      richText: null,
    },
    {
      type: 'HUNDRED',
      subType: 'icon',
      title: 'takhayer-HUNDRED-1-title',
      subtitle: 'takhayer-HUNDRED-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <TakhayerFeature />,
      backgroundColor: 'normal',
      richText: null,
    },
    {
      type: 'SIXTY-FULL',
      subType: 'cta',
      title: 'after-sales-banner-full-main-text',
      titleSuffix: 'after-sales-banner-full-main-text-sffix',
      subtitle: 'after-sales-banner-full-sub-text',
      imageShouldSwitchLocale: false,
      imageUrl: {
        desktop: '/after-sales-banner.png',
        mobile: '/after-sales-banner.png',
      },
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: '/auto-leasing/after-sales-services',
      icon: null,
      richText: null,
    },
    // {
    //   type: 'SIXTY',
    //   subType: 'cta',
    //   title: 'flexi-SIXTY-2-title',
    //   subtitle: null,
    //   imageShouldSwitchLocale: true,
    //   imageUrl: {
    //     desktop:
    //       '/assets/SVG Assets/SVG - Plain/02-06 After Sales Feature Mobile.svg',
    //     mobile:
    //       '/assets/SVG Assets/SVG - With Image/03-02 After Sales Feature Mobile.svg',
    //   },
    //   fancyTitle: null,
    //   ctaTitle: null,
    //   ctaHref: '/auto-leasing/after-sales-services',
    //   icon: null,
    //   richText: null,
    // },
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: 'flexi-SEVENTY-1-title',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: flexibleIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'auto-leasing-THIRTY-1-title',
      subtitle: 'default-auto-leasing-30-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ShieldIcon />,
      richText: null,
    },
  ],
  takhayer: [
    {
      type: 'SIXTY',
      subType: 'svg',
      title: 'takhayer-SIXTY-1-title',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <TakhayerFeature1 />,
      richText: null,
    },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'takhayer-FORTY-1-title',
      subtitle: 'takhayer-FORTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <CoinStack />,
      richText: null,
    },
    {
      type: 'HUNDRED',
      subType: 'icon',
      title: 'takhayer-HUNDRED-1-title',
      subtitle: 'takhayer-HUNDRED-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <TakhayerFeature />,
      backgroundColor: 'normal',
      richText: null,
    },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'takhayer-FORTY-2-title',
      subtitle: null,
      imageUrl:
        '/assets/desktop/Leasing/03-1%20Leasing%20Feature%20Used%20New.jpg',
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      richText: null,
    },
    {
      type: 'SIXTY',
      subType: 'cta',
      title: 'takhayer-SIXTY-2-title',
      subtitle: null,
      imageUrl:
        '/assets/desktop/Leasing/After%20Sales/02%20Feature%20After%20Sales.png',
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: '/auto-leasing/after-sales-services',
      icon: null,
      richText: null,
    },
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: 'takhayer-SEVENTY-1-title',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: flexibleIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'auto-leasing-THIRTY-1-title',
      subtitle: 'default-auto-leasing-30-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ShieldIcon />,
      richText: null,
    },
  ],
  'personal-finance-instant': [
    {
      type: 'SIXTY',
      subType: 'svg',
      title: 'personal-finance-instant-SIXTY-1-title',
      subtitle: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      adjustIconTop: 50,
      icon: <PersonalFinanceRebus />,
      richText: null,
    },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'personal-finance-instant-FORTY-1-title',
      subtitle: 'personal-finance-instant-FORTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <CoinStack />,
      richText: null,
    },
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: 'takhayer-SEVENTY-1-title',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: personalFinanceIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'personal-finance-instant-THIRTY-1-title',
      subtitle: 'personal-finance-instant-THIRTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ClockIcon />,
      richText: null,
    },
  ],
  'personal-finance-standard': [
    {
      type: 'SIXTY',
      subType: 'svg',
      title: 'personal-finance-standard-SIXTY-1-title',
      subtitle: null,
      imageUrl: '/assets/SVG Assets/SVG - Plain/02-1 Standard PF Feature.svg',
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      richText: null,
    },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'personal-finance-standard-FORTY-1-title',
      subtitle: 'personal-finance-standard-FORTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <CoinStack />,
      richText: null,
    },
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: 'takhayer-SEVENTY-1-title',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: personalFinanceIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'personal-finance-standard-THIRTY-1-title',
      subtitle: 'personal-finance-standard-THIRTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ArrowDownward />,
      richText: null,
    },
  ],
  'personal-finance-buyout': [
    {
      type: 'SIXTY',
      subType: 'svg',
      title: 'personal-finance-buyout-SIXTY-1-title',
      subtitle: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      adjustIconTop: 50,
      icon: <PersonalFinanceBuyoutFeature />,
      richText: null,
    },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'personal-finance-buyout-FORTY-1-title',
      subtitle: 'personal-finance-buyout-FORTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <CoinStack />,
      richText: null,
    },
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: 'flexible',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: personalFinanceIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'personal-finance-buyout-THIRTY-1-title',
      subtitle: 'personal-finance-buyout-THIRTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ShieldIcon />,
      richText: null,
    },
  ],
  'after-sales-services': [
    {
      type: 'FORTY-AFTER-SALES',
      subType: 'cta',
      title: 'after-sales-services-FORTY-1-title',
      imageUrl: null,
      fancyTitle: null,
      ctaType: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <TasksIcon />,
      richText: null,
    },
    {
      type: 'SIXTY-AFTER-SALES',
      subType: 'svg',
      title: 'after-sales-services-SIXTY-1-title',
      customWidth: '370px',
      imageShouldSwitchLocale: true,
      imageUrl: {
        desktop: '/assets/SVG Assets/SVG - Plain/02-01 After Sales Feature.svg',
        mobile:
          '/assets/SVG Assets/SVG - Plain/02-01 After Sales Feature Mobile.svg',
      },
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      richText: null,
    },
    {
      type: 'SIXTY-AFTER-SALES',
      subType: 'svg',
      title: 'after-sales-services-SIXTY-3-title',
      customWidth: '370px',
      imageShouldSwitchLocale: true,
      imageUrl: {
        desktop:
          '/assets/SVG Assets/SVG - Plain/after_sales_updated/02-03 After Sales Feature-1.svg',
        mobile:
          '/assets/SVG Assets/SVG - Plain/after_sales_updated/02-03 After Sales Feature Mobile.svg',
      },
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ClockIcon />,
      richText: null,
    },
    {
      type: 'FORTY-AFTER-SALES',
      subType: 'cta',
      title: 'after-sales-services-FORTY-2-title',
      imageUrl: null,
      fancyTitle: null,
      ctaType: 'button',
      ctaTitle: 'after-sales-services-FORTY-2-cta',
      scrollTo: '#footer-main',
      ctaHref: null,
      icon: <ArrowDownward />,
      richText: null,
    },
    {
      type: 'FORTY-AFTER-SALES',
      subType: 'image',
      title: 'after-sales-services-FORTY-3-title',
      imageShouldSwitchLocale: true,
      imageUrl: {
        desktop:
          '/assets/SVG Assets/SVG - Plain/after_sales_updated/02-05 After Sales Feature.svg',
        mobile:
          '/assets/SVG Assets/SVG - Plain/after_sales_updated/02-05 After Sales Feature Mobile.svg',
      },
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ClockIcon />,
      richText: null,
    },
    {
      type: 'SIXTY-AFTER-SALES',
      subType: 'svg',
      title: 'after-sales-services-SIXTY-4-title',
      imageShouldSwitchLocale: true,
      customWidth: '370px',
      imageUrl: {
        desktop:
          '/assets/SVG Assets/SVG - Plain/after_sales_updated/02-04 After Sales Feature.svg',
        mobile:
          '/assets/SVG Assets/SVG - Plain/after_sales_updated/02-04 After Sales Feature.svg',
      },
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ClockIcon />,
      richText: null,
    },
  ],
  'self-employed': [
    {
      type: 'SIXTY',
      subType: 'svg',
      title: 'monthly-SIXTY-1-title',
      subtitle: null,
      imageShouldSwitchLocale: true,
      imageUrl: '/assets/SVG Assets/SVG - Plain/02-01 Monthly Feature.svg',
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      richText: null,
    },
    {
      type: 'TWENTY',
      subType: 'icon',
      title: 'self-employed-TWENTY-1-title',
      subtitle: 'self-employed-TWENTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <CoinStack />,
      richText: null,
    },
    {
      type: 'TWENTY',
      subType: 'icon',
      title: 'self-employed-TWENTY-2-title',
      subtitle: 'self-employed-TWENTY-2-subtitle',
      disclaimer: true,
      disclaimerText: 'self-employed-TWENTY-1-disclaimer',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <FinishFlagICon />,
      richText: null,
    },
    {
      type: 'FORTY',
      subType: 'icon',
      title: 'monthly-FORTY-2-title',
      subtitle: null,
      imageUrl:
        '/assets/desktop/Leasing/03-1%20Leasing%20Feature%20Used%20New.jpg',
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      richText: null,
    },
    {
      type: 'SIXTY',
      subType: 'cta',
      title: 'monthly-SIXTY-2-title',
      subtitle: null,
      imageShouldSwitchLocale: true,
      imageUrl: {
        desktop:
          '/assets/SVG Assets/SVG - Plain/02-06 After Sales Feature Mobile.svg',
        mobile:
          '/assets/SVG Assets/SVG - With Image/03-02 After Sales Feature Mobile.svg',
      },
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: '/auto-leasing/after-sales-services',
      icon: null,
      richText: null,
    },
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: '50-50-SEVENTY-1-title',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: selfEmployedIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'self-employed-THIRTY-1-title',
      subtitle: 'self-employed-THIRTY-1-subtitle',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <ShieldIcon />,
      richText: null,
    },
  ],
}
